import { getBaseURL } from '../config/entorno';

export function abrirGmailLive({ token, onInbox, onError } = {}) {
  if (!token || typeof EventSource === 'undefined') return () => {};
  const base = getBaseURL();
  const url = `${base}/api/gmail/events?token=${encodeURIComponent(token)}`;
  let closed = false;
  let source;
  try {
    source = new EventSource(url);
  } catch {
    return () => {};
  }
  source.addEventListener('inbox', (ev) => {
    if (closed || typeof onInbox !== 'function') return;
    try {
      onInbox(JSON.parse(ev.data || '{}'));
    } catch {
      onInbox({ type: 'inbox-changed' });
    }
  });
  source.onerror = () => {
    if (!closed && typeof onError === 'function') onError();
  };
  return () => {
    closed = true;
    try {
      source.close();
    } catch {
      /* ignore */
    }
  };
}
